import { useEffect, useRef } from 'react';
import type { Dispatch } from 'react';
import { useEventDatasetRetentionCeiling } from './useEventDatasets';
import type { DatasetFormAction } from '../utils/datasetFormUtils';

/**
 * A new dataset starts at the raw archive's retention, unless a definition it starts from already sets one or the
 * operator typed one before the ceiling arrived. Gives the helper text the retention field shows.
 */
export function useDatasetRetentionStart(
  customerId: string,
  editing: boolean,
  retentionDays: string,
  dispatch: Dispatch<DatasetFormAction>,
): string {
  const { ceiling, error } = useEventDatasetRetentionCeiling(customerId, !editing);
  const ceilingDays = ceiling?.retention_days;
  const startRetention = useRef(retentionDays === '');
  useEffect(() => {
    if (startRetention.current && ceilingDays != null && retentionDays === '') {
      startRetention.current = false;
      dispatch({ type: 'SET_FIELD', field: 'retentionDays', value: String(ceilingDays) });
    }
  }, [ceilingDays, retentionDays, dispatch]);
  if (error) return `The raw archive retention could not be read: ${error}`;
  if (ceiling && ceiling.retention_days == null) return 'Raw is kept indefinitely; choose any retention';
  return 'At most the raw archive retention';
}
